import React from "react";

import { useEnvironment } from "@SonarCX/providers/EnvironmentProvider";

type UseDetectInstanceProps = {
  name: string;
};

const useDetectInstance = ({ name }: UseDetectInstanceProps) => {
  const { env } = useEnvironment();

  const isMatched = React.useMemo(() => {
    if (!env) {
      return false;
    }

    const envName: string = env.name;
    return envName.toLocaleLowerCase().includes(name.toLocaleLowerCase());
  }, [env, name]);

  return {
    isMatched,
  };
};

export default useDetectInstance;
